import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ModalAlert from '../../components/ModalAlert';
import { getContacts } from '../../utils/common';
import crmservices from '../../wsclient/';
import ChangeMWPasswordView from './ChangeMWPasswordView';

export default function ChangeMWPassword(props) {
    const { t } = useTranslation();

    const [showLoading, onShowLoading] = useState(false);
    const [info, setInfo] = useState(null);
    const [error, setError] = useState({
        showAlert: false,
        close: true,
        message: '',
        status: '',
    });

    const onValidateFields = (values) => {
        let valid = true;
        let { new_password, confirm_password } = values;
        if(new_password && confirm_password && (new_password !== confirm_password)){
            valid = false;
            showAlert(t('ERROR'), t('enter_the_same_password'));
        }
        return valid;
    }

    const onSubmit = async (values) => {
        onShowLoading(true);
        console.log("values====", values);
        try {
            let { old_password, new_password } = values;
            let valid = onValidateFields(values);
            if(valid) {
                let contacts = getContacts();
                let result = await crmservices.contacts.changeMwarePassword({
                    current_username: contacts && contacts.email ? contacts.email : null,
                    current_password: old_password,
                    new_username: contacts && contacts.email ? contacts.email : null,
                    new_password: new_password,
                });
                console.log("result changeMWPassword===", result);
                if (result.code === 'OK') {
                    showAlert(t('SUCCESS'), t('CHANGE_PASSWORD_SUCCESS'));
                    props.onClose();
                }
                else {
                    let mess = result.data && result.data.message ? result.data.message : t('CHANGE_PASSWORD_FAIL');
                    showAlert(t('ERROR'), mess);
                }
            }
        }
        catch (ex) {
            console.log("change mw password exception===", ex);
        }
        onShowLoading(false);
    }

    const showAlert = (status, message, close) => {
        onShowLoading(false);
        setError({
            showAlert: true,
            message: message,
            status: status,
            close: close
        });
    }

    const onCloseAlert = () => {
        if (error.close)
            props.handleDrawerOtherToggle("change_mw_password");
        onShowLoading(false);
        setError({
            showAlert: false,
            message: '',
            status: '',
            close: true
        });
    }

    return (
        <>
            <ChangeMWPasswordView
                open={props.open}
                info={info}
                onClose={props.onClose}
                onSubmit={onSubmit}
            />
            <ModalAlert
                open={error.showAlert}
                onClose={onCloseAlert}
                hideHeader={true}
                message={error.message}
                error={error.status}
            />
        </>
    );
}